import cn from 'classnames'

import { TabBody } from '@components/Tabs/components/TabBody'
import { Pagination } from '@components/Pagination'
import { OptionSelect } from '@components/OptionSelect/OptionSelect'
import { NoBookIcon } from '@components/icons/NoBookIcon'
import { EbookProfileCard } from '@features/profile/components/EbookProfileCard'
import { EbookProfileCardSkeleton } from '@features/profile/components/EbookProfileCard/EbookProfileCardSkeleton'
import SelectPerPage from '@components/Pagination/components/SelectPerPage/SelectPerPage'
import { BookEnum } from '@interfaces/BookEnum'
import { ProfileEbookProps } from './interface'

const bookTypeOptions = [
  { value: null, label: 'ทั้งหมด' },
  { value: BookEnum.NOVEL, label: 'นิยาย' },
  { value: BookEnum.MANGA, label: 'การ์ตูน' },
]

const perpageOptions = [
  { label: '10', value: 10 },
  { label: '20', value: 20 },
  { label: '30', value: 30 },
]

export function ProfileEbook({
  datas,
  isLoading,
  bookType,
  searchParam,
  penNameOptions,
  page,
  perpage,
  total,
  perpageChange,
  handlePaginationChange,
  handleBookTypeChange,
  handlePenNameChange,
}: ProfileEbookProps) {
  return (
    <TabBody tabId='ebook'>
      <div className='relative flex text-[14px] text-secondary-1'>
        {bookTypeOptions.map((menu, i) => (
          <button
            key={i}
            className={cn('flex py-[10px] px-[20px] font-light z-10', {
              'border-b-[3px] border-secondary dark:border-dark-10 font-bold text-secondary dark:text-dark-10':
                bookType === menu.value,
            })}
            onClick={() => handleBookTypeChange(menu.value)}
          >
            {menu.label}
          </button>
        ))}
        <div className='absolute w-full h-[1px] bottom-0 bg-gray-3 dark:bg-purple z-0' />
      </div>

      <div className='border-t border-gray-3 dark:border-purple'>
        <div className='flex desktop-tablet:space-x-[10px] py-[20px] mobile:grid desktop:items-center mobile:gap-y-[20px]'>
          <OptionSelect
            className='w-[180px] mobile:w-full'
            title='นามปากกา'
            value={searchParam.penNameId}
            handleSelect={handlePenNameChange}
            options={[{ value: null, label: 'ทั้งหมด' }, ...penNameOptions]}
          />
          <div className='flex grow items-center justify-between'>
            <div className='text-secondary-1 text-sm font-light'>
              <span className='tablet-mobile:hidden'>จำนวนงานเขียน :</span>
              <span className='text-secondary dark:text-dark-10 font-bold desktop:ml-[4px]'>
                {total.toLocaleString()}
              </span>
              <span className='ml-[4px] tablet-mobile:ml-[10px]'>รายการ</span>
            </div>
            <SelectPerPage
              value={perpage}
              handleSelect={perpageChange}
              options={perpageOptions}
            />
          </div>
        </div>

        <div className='flex flex-col space-y-[20px]'>
          {isLoading ? (
            <>
              {[...Array(3)].map((_, i) => (
                <EbookProfileCardSkeleton key={i} />
              ))}
            </>
          ) : datas.length ? (
            <>
              {datas.map(data => (
                <EbookProfileCard
                  key={data.id}
                  id={data.id}
                  title={data.title}
                  cover={data.coverImgPath}
                  chapterCount={data.totalEbookSeries}
                  avgRating={data.avgEbookRating}
                  commentCount={data.totalEbookReview}
                  likeCount={data.totalEbookWishlist}
                  bookType={data.bookType}
                  redirect={`/my-writing/${data.id}/ebook`}
                />
              ))}
              <Pagination
                page={page}
                perpage={perpage}
                total={total}
                pageChange={handlePaginationChange}
              />
            </>
          ) : (
            <div className='flex flex-col items-center justify-center pt-[40px]'>
              <NoBookIcon className='w-[120px] h-[119px] mb-[10px]' />
              <span className='font-mitr font-medium text-[18px] text-gray-12 dark:text-dark-10 mb-[31px]'>
                ไม่พบอีบุ๊ก
              </span>
            </div>
          )}
        </div>
      </div>
    </TabBody>
  )
}
